import cn from 'classnames'
import {FC} from 'react'

import {HOVER_TRANSITION} from '@/theme/cssTransitions'
import {theme} from '@/theme/theme'
import {
  MOBILE_SCREENSIZE,
  TABLET_SCREENSIZE,
  USER_TABLET_SCREENSIZE,
} from '@/utils/styles/breakpoints'

type CardWrapperProps = {
  numOfCardsPerRow?: number
  isHoverable?: boolean
  fullWidth?: boolean
  hasBorder?: boolean
  gap?: string
}

export const CardWrapper: FC<React.PropsWithChildren<CardWrapperProps>> = ({
  numOfCardsPerRow = 3,
  isHoverable = true,
  fullWidth = false,
  hasBorder = true,
  gap = theme.spacing[3],
  children,
}) => (
  <>
    <div
      className={cn(
        'card-wrapper',
        isHoverable && 'hoverable',
        fullWidth && 'full-width',
        hasBorder && 'outlined',
      )}
    >
      {children}
    </div>

    <style jsx>{`
      .card-wrapper {
        width: 100%;
        max-width: calc(100% / ${numOfCardsPerRow} - ${gap} * 2);
        margin: ${gap};
        transition: box-shadow ${HOVER_TRANSITION}ms ease-in-out;
      }
      .outlined {
        border-radius: 12px;
        box-shadow: inset 0px 0px 0px 1px ${theme.palette.gray[200]};
      }
      .hoverable:hover {
        box-shadow: inset 0px 0px 0px 1px ${theme.palette.gray[300]};
      }
      .full-width {
        max-width: inherit;
        margin: 0;
      }
      .full-width + .full-width {
        margin-top: ${theme.spacing[4]};
      }
      @media ${TABLET_SCREENSIZE} {
        .card-wrapper:not(.full-width) {
          max-width: calc(100% / ${numOfCardsPerRow} - ${theme.spacing[4]});
          margin: ${theme.spacing[2.5]};
        }
      }
      @media ${USER_TABLET_SCREENSIZE} {
        .card-wrapper:not(.full-width) {
          max-width: calc(100% / 2 - ${theme.spacing[4]});
        }
      }
      @media ${MOBILE_SCREENSIZE} {
        .card-wrapper,
        .card-wrapper:not(.full-width) {
          margin: 0;
          max-width: inherit;
        }
        .card-wrapper + .card-wrapper.outlined {
          margin-top: ${theme.spacing[3]};
        }
        .card-wrapper + .card-wrapper {
          margin-top: ${theme.spacing[4]};
        }
      }
    `}</style>
  </>
)
